<template>
  <svg
    ref="svgRef"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="shield-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stop-color="#7F77DD" />
        <stop offset="100%" stop-color="#5DCAA5" />
      </linearGradient>
    </defs>
    <ellipse
      ref="glowRef"
      class="shield-glow"
      cx="40"
      cy="42"
      rx="28"
      ry="28"
      fill="url(#shield-gradient)"
    />
    <g ref="bodyRef" class="shield-body">
      <path
        d="M40 10 L62 20 L62 42 C62 55 40 68 40 68 C40 68 18 55 18 42 L18 20 Z"
        fill="url(#shield-gradient)"
        opacity="0.15"
      />
      <path
        d="M40 10 L62 20 L62 42 C62 55 40 68 40 68 C40 68 18 55 18 42 L18 20 Z"
        stroke="url(#shield-gradient)"
        stroke-width="2.5"
        fill="none"
      />
    </g>
    <path
      ref="checkRef"
      class="shield-check"
      d="M28 40 L37 50 L53 31"
      stroke="url(#shield-gradient)"
      stroke-width="3.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup>
import { ref } from 'vue';

const svgRef = ref(null);
const glowRef = ref(null);
const bodyRef = ref(null);
const checkRef = ref(null);

const animate = () => {
  [glowRef.value, bodyRef.value, checkRef.value].forEach((el) => {
    if (!el) return;
    el.style.animation = 'none';
    void el.offsetHeight;
    el.style.animation = '';
  });
};

defineExpose({ animate });
</script>

<style scoped>
.shield-body {
  animation: shieldPop 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s both;
  transform-origin: center bottom;
}

@keyframes shieldPop {
  0% {
    transform: scale(0) translateY(10px);
    opacity: 0;
  }
  100% {
    transform: scale(1) translateY(0);
    opacity: 1;
  }
}

.shield-check {
  stroke-dasharray: 40;
  stroke-dashoffset: 40;
  animation: drawCheck 0.5s ease-out 0.75s forwards;
}

@keyframes drawCheck {
  to {
    stroke-dashoffset: 0;
  }
}

.shield-glow {
  animation: pulseGlow 2.5s ease-in-out 1.2s infinite;
  transform-origin: center;
}

@keyframes pulseGlow {
  0%,
  100% {
    opacity: 0;
    transform: scale(0.85);
  }
  50% {
    opacity: 0.18;
    transform: scale(1.15);
  }
}
</style>
